import { IPromise, IHttpService } from "angular";
import { IAssignee } from "./models";
import { ICollection } from "../models";
import { EnvironmentService } from "@gtmhub/env";
import { IRestLayerRequest } from "@gtmhub/core";
import { getCurrentUserId } from "@gtmhub/users";
import { INgRedux } from "@gtmhub/state-management";
import { IAssigneesStoreState } from "@gtmhub/assignees";

export class AssigneeService {
  public static $inject = ["$http", "EnvironmentService", "$ngRedux"];

  constructor(private $http: IHttpService, private env: EnvironmentService, private $ngRedux: INgRedux) {}

  public getAssignees(params: IRestLayerRequest): IPromise<ICollection<IAssignee>> {
    const url = this.env.getApiEndpointV2("/assignees");
    return this.$http.get<ICollection<IAssignee>>(url, { params }).then((response) => response.data);
  }
  public getActiveAssigneesOnly = (ownersIds: string[]): string[] => {
    const assignees = Object.values(this.$ngRedux.getState<IAssigneesStoreState>().assignees.map);
    const activeOwnersIds = ownersIds?.filter((id) => assignees.some((a) => a.id === id && a.isActive !== false));
    if (activeOwnersIds?.length === 0) {
      activeOwnersIds.push(getCurrentUserId());
    }
    return activeOwnersIds;
  };
}
